export default "__VITE_ASSET__Ove5ac4A__"